export default __webpack_public_path__ + "static/media/HOLTELEM-2019-59.e2518689.jpg";